document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.documents-block__group-header').forEach((btn) => {
    btn.addEventListener('click', () => {
      const group = btn.closest('.documents-block__group')
      group.classList.toggle('is-open')
    })
  })
})
